import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import HelpIcon from "@mui/icons-material/Help";
import FeedbackIcon from "@mui/icons-material/Feedback";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import "./scrollBar.css";
import { useAuth } from "../../../provider/authProvider";
import { Link } from "react-router-dom";
import HelpCenterModal from "./HelpCenter";
import RequestFeature from "./RequestFeature";
import MentorProfileStatusProgress from "./MentorProfileStatusProgress";
import { getRole } from "../../../DecodeToken/DecodeToken";
import EventPopup from "../../../Pages/CodeQueueEvents/EventPopup";

function Home() {
  const { getUserName } = useAuth();
  const [isFeatureRequestPopUpVisible, setIsFeatureRequestPopUpVisible] =
    useState(false);
  const [isHelpCenterOpen, setHelpCenterOpen] = useState(false);
  const [hasProfileApproved, setHasProfileApproved] = useState(false);
  const role = getRole();

  return (
    <div className="h-full flex-col justify-between">
      <div className="ml-8 lg:ml-2">
        <h2 className="text-xl font-bold md:text-2xl">Hi, {getUserName()}</h2>
      </div>

      {role === "mentor" && !hasProfileApproved && (
        <MentorProfileStatusProgress
          setHasProfileApproved={setHasProfileApproved}
        />
      )}

      {(hasProfileApproved || role === "user") && (
        <h1 className="text-center text-4xl text-gray-400 py-10">
          Upcoming...
        </h1>
      )}
      {/* <EventPopup /> */}
      <section className="help-section my-4">
        <h2 className="text-2xl font-bold mb-4 mt-4">Need some help?</h2>
        <div className="help-options grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          <div className="help-card w-full flex flex-col bg-gray-50 border border-gray-300 rounded-lg overflow-hidden">
            <div className="image-container bg-gray-300 h-28 p-2 flex justify-start items-center pl-5">
              <FeedbackIcon sx={{ fontSize: 50 }} />
            </div>
            <div className="text-container bg-white p-1 pb-0">
              <h3 className="text-lg font-bold mb-2">Feedback</h3>
              <Link
                className="text-base text-gray-800 underline"
                onClick={() => {
                  setIsFeatureRequestPopUpVisible(
                    !isFeatureRequestPopUpVisible
                  );
                }}
              >
                Request feature
              </Link>
              <p className="text-sm mt-2 text-gray-600 mb-3">
                Share your feature request or feedback, we're all ears
              </p>
            </div>
          </div>
          <div className="help-card w-full flex flex-col bg-gray-50 border border-gray-300 rounded-lg overflow-hidden">
            <div className="image-container bg-gray-300 h-28 p-2 flex justify-start items-center pl-5">
              <HelpIcon sx={{ fontSize: 50 }} />
            </div>
            <div className="text-container bg-white p-1 pb-0">
              <h3 className="text-lg font-bold mb-2">Support</h3>
              <div className="">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setHelpCenterOpen(true);
                  }}
                  className="text-base text-gray-800 underline"
                >
                  Help Center
                </Link>

                {/* Help Center Modal */}
                <HelpCenterModal
                  isOpen={isHelpCenterOpen}
                  onClose={() => setHelpCenterOpen(false)}
                />
              </div>
              <p className="text-sm mt-2 text-gray-600">
                Reach out to community, support or your personal assistant
              </p>
            </div>
          </div>
          <div className="help-card w-full flex flex-col bg-gray-50 border border-gray-300 rounded-lg overflow-hidden">
            <div className="image-container bg-gray-300 h-28 p-2 flex justify-start items-center pl-5">
              <LocalAtmIcon sx={{ fontSize: 50 }} />
            </div>
            <div className="text-container bg-white p-1 pb-0">
              <h3 className="text-lg font-bold mb-2">Earn More</h3>
              <NavLink
                to={"/dashboard/rewards"}
                className="text-base text-gray-800 underline"
              >
                Invite and earn
              </NavLink>
              <p className="text-sm mt-2 text-gray-600">
                Invite your friends to CodeQueue and get instant rewards
              </p>
            </div>
          </div>
        </div>
      </section>
      {isFeatureRequestPopUpVisible && (
        <RequestFeature
          setIsFeatureRequestPopUpVisible={setIsFeatureRequestPopUpVisible}
        />
      )}
    </div>
  );
}

export default Home;
